import { jsx as o } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ o(
  "path",
  {
    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L17 15.5858V9.0625C17 8.51022 17.4477 8.0625 18 8.0625C18.5523 8.0625 19 8.51022 19 9.0625V18C19 18.5523 18.5523 19 18 19H9.0625C8.51022 19 8.0625 18.5523 8.0625 18C8.0625 17.4477 8.51022 17 9.0625 17H15.5858L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
export {
  t as default
};
